import React from 'react';
import { ExternalLink } from '../../components';

function DataPrivacyGerman() {
  return (
    <div style={{ lineHeight: '1.6', fontFamily: 'Arial, sans-serif', padding: '20px' }}>
      <h1 style={{ fontSize: '46px !important', lineHeight: '46px !important' }}>
        ANHANG 1: VEREINBARUNG ZUR DATENVERARBEITUNG
      </h1>

      <p>
        Dieser Nachtrag zur Datenverarbeitung (der „DPA“) bildet Anhang 1 der Nutzungsbedingungen der
        Website (die „Vereinbarung“) und ist integraler Bestandteil derselben.
      </p>

      <p>
        <strong>ZWISCHEN:</strong>
      </p>

      <p>
        „VIVIANLAB LTD“ mit Sitz in 1612 SOFIA BUL. TSAR BORIS III № 81 ET.1, AP.1, VAT
        BG207933919 (im Folgenden „das Unternehmen“ oder „VivianLab“)
        <br />
        UND
        <br />
        die Fachperson – der Anbieter – der Nutzer (im Folgenden „Anbieter“ oder „Auftraggeber“),
        der die Vereinbarung angenommen hat.
      </p>

      <p>(jeweils eine „Partei“ und zusammen die „Parteien“).</p>

      <p>
        <strong>HINTERGRUND</strong>
      </p>

      <p>
        (A) Der Kunde hat den Vertrag über die Erbringung von Vermittlungsdienstleistungen durch das
        Unternehmen über die Plattform (die „Dienstleistungen“) angenommen.
        <br />
        (B) Diese DPA ist Bestandteil des Vertrags und spiegelt die Vereinbarung der Parteien
        hinsichtlich der Verarbeitung personenbezogener Daten gemäß den Anforderungen der
        Datenschutzgesetzgebung wider.
        <br />
        (C) Im Rahmen der Erbringung der Dienste für den Kunden gemäß der Vereinbarung verarbeitet das
        Unternehmen personenbezogene Daten im Auftrag des Kunden. Der Kunde fungiert als
        Verantwortlicher und das Unternehmen als Auftragsverarbeiter.
        <br />
        (D) Die Arten von personenbezogenen Daten und die Kategorien von betroffenen Personen, die
        vom Unternehmen in seiner Eigenschaft als Auftragsverarbeiter im Rahmen dieser DPA verarbeitet
        werden, sind in Anhang 1 dieser DPA näher aufgeführt.
      </p>

      <p>
        <strong>VEREINBARTE BEDINGUNGEN</strong>
      </p>

      <h3>1. Auslegung</h3>

      <p>1.1 Für diese Datenschutzvereinbarung gelten die folgenden Begriffsbestimmungen und Auslegungsregeln.</p>

      <p>
        „Verbundenes Unternehmen“ bezeichnet jede juristische Person, die zu einem bestimmten
        Zeitpunkt das betreffende Unternehmen direkt oder indirekt kontrolliert, von diesem
        kontrolliert wird oder mit diesem unter direkter oder indirekter gemeinsamer Kontrolle steht.
        <br />
        „Geschäftskontaktdaten“ bezeichnet personenbezogene Daten, die die beruflichen Kontaktdaten
        der Mitarbeiter jeder Partei enthalten.
        <br />
        „Kundendaten“ bezeichnet personenbezogene Daten, die im Zusammenhang mit den Dienstleistungen
        verarbeitet werden und die:
        <br />
        (a) dem Unternehmen oder einem Dritten vom Kunden (oder einem Dritten im Namen des Kunden)
        zur Verfügung gestellt oder bereitgestellt werden, oder
        <br />
        (b) vom Unternehmen oder einem Dritten im Namen des Kunden erhoben werden.
        <br />
        „Kontrolle“ bezeichnet den direkten oder indirekten Besitz der Befugnis, die Geschäftsführung
        und die Richtlinien einer anderen juristischen Person zu lenken oder deren Lenkung zu
        bewirken (sei es durch den Besitz von Stimmrechtsanteilen, durch Vertrag oder auf andere
        Weise), wobei die Begriffe „Kontrollierende“ und „Kontrollierte“ entsprechend auszulegen
        sind.
        <br />
        „Verantwortlicher“, „Auftragsverarbeiter“, „betroffene Person“, „Verarbeitung“, „verarbeiten“
        und „verarbeitet“ haben jeweils die in den Datenschutzvorschriften festgelegte Bedeutung.
        <br />
        „Datenschutzvorschriften“ bezeichnet die Verordnung (EU) 2016/679 (die „DSGVO“) sowie alle
        nationalen Rechtsvorschriften zum Datenschutz in ihrer jeweils gültigen Fassung.
        <br />
        „Standardvertragsklauseln der Europäischen Kommission“ bezeichnet eine Vereinbarung, die die
        Klauseln enthält, die in der von der Europäischen Kommission genehmigten Standardvereinbarung
        für die Übermittlung personenbezogener Daten außerhalb des EWR gemäß dem Beschluss der
        Europäischen Kommission vom 4. Juni 2021 enthalten sind.
        <br />
        „Personenbezogene Daten“ haben die in den Datenschutzgesetzen festgelegte Bedeutung und
        beziehen sich ausschließlich auf personenbezogene Daten oder Teile davon:
        <br />
        (a) die dem Unternehmen vom Kunden oder in dessen Auftrag zur Verfügung gestellt wurden;
        und/oder
        <br />
        (b) die vom Unternehmen im Auftrag des Kunden im Rahmen der Erbringung der Dienstleistungen
        erhoben oder erstellt wurden, wobei in jedem Fall der Kunde der Verantwortliche ist und die
        personenbezogenen Daten vom Unternehmen bei der Erbringung der Dienstleistungen verarbeitet
        werden.
        <br />
        „Aufsichtsbehörde“ bezeichnet die nationale Datenschutzbehörde gemäß den Datenschutzgesetzen.
        <br />
        „Sicherheitsverletzung“ bezeichnet eine Verletzung der Sicherheit, die zur versehentlichen
        oder unrechtmäßigen Zerstörung, zum Verlust, zur Veränderung, zur unbefugten Offenlegung von
        oder zum unbefugten Zugriff auf übermittelte, gespeicherte oder anderweitig verarbeitete
        personenbezogene Daten führt.
        <br />
        „Unterauftragsverarbeiter“ bezeichnet einen Auftragsverarbeiter, der vom Unternehmen beauftragt
        wurde, Kundendaten im Zusammenhang mit den direkt vom Unternehmen erbrachten Dienstleistungen
        zu verarbeiten.
        <br />
        „Technische und organisatorische Maßnahmen“ bezeichnet die technischen und organisatorischen
        Maßnahmen, die von den Parteien gemäß Artikel 32 der DSGVO berücksichtigt werden.
      </p>

      <p>
        1.2 Die Anhänge sind Bestandteil dieser DPA und gelten als in den Hauptteil dieser DPA
        vollständig aufgenommen.
        <br />
        1.3 Im Falle eines Widerspruchs oder einer Unklarheit zwischen einer Bestimmung dieser DPA
        und den Bestimmungen der Vereinbarung haben die Bestimmungen dieser DPA Vorrang.
      </p>

      <h3>2. VERARBEITUNG PERSONENBEZOGENER DATEN</h3>

      <p>
        2.1 Rollen der Parteien
        <br />
        (a) Die Parteien erkennen an und vereinbaren, dass im Hinblick auf die Verarbeitung
        personenbezogener Daten der Kunde (Anbieter) der für die Datenverarbeitung Verantwortliche
        ist, das Unternehmen (VivianLab) der Auftragsverarbeiter ist und dass das Unternehmen etwaige
        Unterauftragsverarbeiter gemäß den in Ziffer 4 unten festgelegten Anforderungen beauftragen
        wird.
      </p>

      <p>
        2.2 Verarbeitung personenbezogener Daten durch den Kunden
        <br />
        (a) Der Kunde hat personenbezogene Daten im Zusammenhang mit den Dienstleistungen gemäß den
        Anforderungen der Datenschutzgesetzgebung zu verarbeiten.
        <br />
        (b) Die Anweisungen des Kunden zur Verarbeitung personenbezogener Daten müssen der
        Datenschutzgesetzgebung entsprechen.
        <br />
        (c) Der Kunde trägt die alleinige Verantwortung für die Richtigkeit, Qualität und
        Rechtmäßigkeit der Kundendaten sowie für die Art und Weise, wie der Kunde die personenbezogenen
        Daten erhoben hat.
        <br />
        (d) Der Kunde gewährleistet und verpflichtet sich, dass:
        <br />
        (i) seine Offenlegung personenbezogener Daten gegenüber dem Unternehmen auf das beschränkt
        ist, was für die Erbringung der Dienstleistungen durch das Unternehmen erforderlich ist;
        <br />
        (ii) diese personenbezogenen Daten zum Zeitpunkt ihrer Übermittlung an das Unternehmen korrekt
        und aktuell sind; und
        <br />
        (iii) er sich auf eine Rechtsgrundlage für die Verarbeitung stützt und auch weiterhin stützen
        wird (einschließlich der Einholung aller erforderlichen gültigen Einwilligungen, insbesondere
        für besondere Kategorien personenbezogener Daten gemäß Anhang 1), bei Bedarf eine Prüfung der
        berechtigten Interessen durchgeführt hat und die erforderlichen Informationshinweise
        bereitstellt, damit das Unternehmen personenbezogene Daten für die Dauer und zu den Zwecken
        der Dienstleistungen rechtmäßig verarbeiten kann.
      </p>

      <p>
        2.3 Verarbeitung personenbezogener Daten durch das Unternehmen
        <br />
        (a) Das Unternehmen verarbeitet personenbezogene Daten im Zusammenhang mit den Dienstleistungen
        gemäß den Anforderungen der Datenschutzgesetzgebung und ausschließlich gemäß den schriftlichen
        Anweisungen des Kunden (einschließlich des Vertrags und der Nutzung der Dienstleistungen).
        <br />
        (b) Das Unternehmen ist angewiesen, personenbezogene Daten für die in Anhang 1 genannten
        Zwecke zu verarbeiten.
        <br />
        (c) Ist das Unternehmen der begründeten Ansicht, dass die vom Kunden erteilten Anweisungen
        bezüglich der Verarbeitung gegen die Datenschutzgesetze verstoßen, so hat das Unternehmen den
        Kunden davon in Kenntnis zu setzen.
        <br />
        (d) Das Unternehmen hat sicherzustellen, dass alle Personen, die von ihm gemäß dieser DPA zur
        Verarbeitung personenbezogener Daten befugt sind, vertraglich zur Wahrung der
        Vertraulichkeit verpflichtet sind und personenbezogene Daten ohne vorherige Zustimmung des
        Kunden nicht an Dritte weitergeben dürfen, es sei denn, dies ist gesetzlich vorgeschrieben
        oder durch den Vertrag gestattet.
      </p>

      <h3>3. RECHTE BETROFFENER PERSONEN</h3>

      <p>
        3.1 Berichtigung, Sperrung und Löschung
        <br />
        (a) Das Unternehmen benachrichtigt den Kunden, soweit dies gesetzlich zulässig ist, bei Erhalt
        einer Beschwerde oder Anfrage, die sich auf die Verpflichtungen des Kunden gemäß den
        Datenschutzgesetzen oder auf personenbezogene Daten bezieht.
        <br />
        (b) Das Unternehmen kommt auf Kosten des Kunden allen wirtschaftlich vertretbaren schriftlichen
        Anweisungen des Kunden nach, um die erforderlichen Maßnahmen zu ermöglichen.
      </p>

      <p>
        3.2 Anfragen betroffener Personen
        <br />
        (a) Das Unternehmen benachrichtigt den Kunden, soweit dies gesetzlich zulässig ist,
        unverzüglich, wenn es von einer betroffenen Person einen Antrag auf Auskunft, Berichtigung,
        Änderung, Einschränkung oder Löschung ihrer personenbezogenen Daten erhält.
        <br />
        (b) Das Unternehmen reagiert, soweit gesetzlich zulässig, nicht auf solche Anträge betroffener
        Personen ohne die vorherige schriftliche Zustimmung des Kunden, es sei denn, um zu bestätigen,
        dass der Antrag den Kunden betrifft und an diesen weitergeleitet wurde.
        <br />
        (c) Das Unternehmen leistet dem Kunden im Rahmen des gesetzlich Zulässigen und soweit der
        Kunde selbst keinen Zugriff auf diese personenbezogenen Daten hat oder nicht in der Lage ist,
        diese zu berichtigen, zu ergänzen, einzuschränken oder zu löschen, innerhalb der vereinbarten
        Fristen wirtschaftlich angemessene Zusammenarbeit und Unterstützung bei der Bearbeitung der
        Anfrage einer betroffenen Person.
        <br />
        (d) Der Kunde trägt alle angemessenen und nachgewiesenen Kosten, die durch die Bereitstellung
        dieser Unterstützung durch das Unternehmen entstehen.
      </p>

      <h3>4. UNTERAUFTRAGSVERARBEITER:INNEN</h3>

      <p>
        4.1 Beauftragung
        <br />
        (a) Der Kunde nimmt zur Kenntnis und erklärt sich damit einverstanden, dass das Unternehmen im
        Zusammenhang mit der Erbringung der Dienstleistungen Unterauftragsverarbeiter einsetzen darf.
        Die derzeitigen Unterauftragsverarbeiter des Unternehmens sind in dessen{' '}
        <ExternalLink href="/de/privacy-policy">Datenschutzerklärung</ExternalLink> aufgeführt und/oder
        werden dem Kunden auf Anfrage zur Verfügung gestellt.
        <br />
        (b) Das Unternehmen verpflichtet alle Unterauftragsverarbeiter, sich schriftlich zur
        Verarbeitung personenbezogener Daten zu verpflichten, wobei die Bedingungen nicht weniger
        streng sein dürfen als die in dieser DPA festgelegten Bestimmungen.
      </p>

      <p>
        4.2 Haftung
        <br />
        (a) Das Unternehmen haftet für die Handlungen und Unterlassungen seiner Unterauftragsverarbeiter
        im Zusammenhang mit der Verarbeitung personenbezogener Daten in demselben Umfang, wie es
        haften würde, wenn es diese Handlungen und Unterlassungen selbst begangen hätte.
      </p>

      <h3>5. SICHERHEIT UND MELDUNG VON VERLETZUNGEN</h3>

      <p>
        Das Unternehmen arbeitet auf Anfrage mit jeder zuständigen Aufsichtsbehörde oder
        Regulierungsstelle bei der Erfüllung ihrer Aufgaben zusammen, unter anderem durch die
        Bereitstellung aller erforderlichen Informationen und Unterstützung gemäß den geltenden
        Datenschutzvorschriften, einschließlich Artikel 31 der DSGVO.
        <br />
        Das Unternehmen ergreift und unterhält geeignete technische und organisatorische Maßnahmen, um
        ein dem Risiko angemessenes Sicherheitsniveau gemäß Artikel 32 DSGVO zu gewährleisten,
        einschließlich, soweit angemessen, Maßnahmen wie Pseudonymisierung und Verschlüsselung,
        Zugriffskontrollen, Sicherungs- und Wiederherstellungsverfahren sowie regelmäßige
        Sicherheitstests.
        <br />
        Im Falle einer Sicherheitsverletzung, die Kundendaten betrifft, benachrichtigt das Unternehmen
        den Kunden unverzüglich, nachdem es davon Kenntnis erlangt hat, und stellt dem Kunden alle
        Informationen zur Verfügung, die vernünftigerweise erforderlich sind, damit der Kunde seinen
        Verpflichtungen gemäß den Artikeln 33 und 34 DSGVO nachkommen kann.
      </p>

      <h3>6. MITTEILUNGEN</h3>

      <p>
        6.1 Das Unternehmen wird den Kunden unverzüglich über jede rechtmäßige Aufforderung zur
        Offenlegung personenbezogener Daten durch eine Aufsichtsbehörde, Strafverfolgungsbehörde oder
        sonstige staatliche Stelle informieren, sofern dies nicht gesetzlich untersagt ist.
      </p>

      <h3>7. RÜCKGABE UND LÖSCHUNG VON KUNDENDATEN</h3>

      <p>
        7.1 Bei Beendigung oder Ablauf der Dienstleistungen oder auf schriftliche Aufforderung des
        Kunden hat das Unternehmen (nach Wahl des Kunden) alle personenbezogenen Daten zu löschen oder
        zurückzugeben, sofern deren Aufbewahrung nicht zur Einhaltung gesetzlicher oder behördlicher
        Vorschriften erforderlich ist.
        <br />
        7.2 Wählt der Kunde die Löschung, so hat das Unternehmen die personenbezogenen Daten so bald wie
        vernünftigerweise möglich und ohne unnötige Verzögerung nach Beendigung oder Ablauf der
        Dienstleistungen zu löschen, es sei denn, die Aufbewahrung ist gesetzlich vorgeschrieben.
        <br />
        7.3 Die Parteien vereinbaren, dass das Unternehmen dem Kunden eine Bescheinigung über die
        Löschung der personenbezogenen Daten nur auf dessen Verlangen aushändigt.
      </p>

      <h3>8. AUDITS UND UNTERSTÜTZUNG</h3>

      <p>
        8.1 Auf begründeten Antrag des Kunden stellt das Unternehmen dem Kunden alle Informationen zur
        Verfügung, die erforderlich sind, um die Einhaltung der in dieser DPA festgelegten
        Verpflichtungen durch das Unternehmen nachzuweisen.
        <br />
        8.2 Der Kunde hat das Recht, die Einhaltung der Verpflichtungen durch das Unternehmen zu
        prüfen, vorausgesetzt, dass:
        <br />
        (a) Prüfungsanträge schriftlich gestellt werden und nicht häufiger als einmal innerhalb eines
        Zeitraums von zwölf Monaten erfolgen;
        <br />
        (b) Prüfungen müssen während der regulären Geschäftszeiten durchgeführt werden und dürfen die
        Geschäftstätigkeit des Unternehmens nicht unangemessen beeinträchtigen;
        <br />
        (c) um eine Prüfung zu beantragen, muss der Kunde mindestens sechs (6) Wochen im Voraus einen
        detaillierten Prüfungsplan vorlegen; und
        <br />
        (d) alle Prüfungen gehen ausschließlich zu Lasten des Kunden.
        <br />
        8.3 Das Unternehmen stellt dem Kunden auf dessen Kosten und nur auf dessen ausdrückliche
        schriftliche Anfrage hin die Unterstützung und Informationen zur Verfügung, die
        vernünftigerweise erforderlich sind, damit der Kunde seiner Verpflichtung zur Durchführung
        einer Datenschutz-Folgenabschätzung oder zur Konsultation einer Aufsichtsbehörde nachkommen
        kann. Zur Vermeidung von Zweifeln sei darauf hingewiesen, dass das Unternehmen nicht
        verpflichtet ist, im Namen des Kunden proaktiv eine Datenschutz-Folgenabschätzung zu
        identifizieren oder einzuleiten.
      </p>

      <h3>9. DATENÜBERMITTLUNGEN AUSSERHALB DES EWR</h3>

      <p>
        9.1 Das Unternehmen darf personenbezogene Daten ohne vorherige schriftliche Genehmigung des
        Kunden nicht außerhalb des Europäischen Wirtschaftsraums („EWR“) verarbeiten, speichern oder
        übermitteln, es sei denn, die Übermittlung erfolgt an einen Unterauftragsverarbeiter und
        unterliegt einem gültigen, rechtmäßigen Übermittlungsmechanismus (wie beispielsweise, aber
        nicht beschränkt auf die Standardvertragsklauseln der Europäischen Kommission).
        <br />
        9.2 Der Kunde erteilt eine allgemeine Genehmigung für Übermittlungen an Unterauftragsverarbeiter
        außerhalb des EWR, wie in Anhang 1 dargelegt, sofern ein gültiger Übermittlungsmechanismus
        vorhanden ist.
      </p>

      <h3>10. HAFTUNG UND FREISTELLUNG</h3>

      <p>
        10.1 Die Parteien vereinbaren, dass die Bestimmungen dieser DPA nicht den Haftungsbeschränkungen
        und -ausschlüssen sowie sonstigen Bestimmungen der Vereinbarung unterliegen, die für die
        betreffenden Dienste gelten.
        <br />
        10.2 Vorbehaltlich der Ziffer 10.1 haftet keine der Parteien im Rahmen dieser DPA für den Verlust
        tatsächlicher oder erwarteter Einnahmen oder Gewinne, den Verlust von Verträgen oder für
        besondere, indirekte oder Folgeschäden jeglicher Art.
        <br />
        10.3 Vorbehaltlich Ziffer 10.1 übersteigt die Gesamthaftung des Unternehmens gegenüber dem
        Anbieter, die sich aus oder im Zusammenhang mit dieser DPA ergibt – unabhängig von der
        Rechtsgrundlage (Vertrag, unerlaubte Handlung, Verletzung gesetzlicher Pflichten, Freistellung
        oder aus sonstigem Grund) – in keinem Fall den Gesamtbetrag von dreitausend Euro (3.000 €).
        <br />
        10.4 Das Unternehmen stellt den Kunden von allen Verlusten, Schäden oder Geldbußen frei, die dem
        Kunden infolge von Ansprüchen oder Maßnahmen der Aufsichtsbehörde entstehen, die direkt aus einer
        Verletzung dieser DPA durch das Unternehmen resultieren.
        <br />
        10.5 Der Kunde stellt das Unternehmen von allen Verlusten, Schäden oder Geldbußen frei, die dem
        Unternehmen infolge von Ansprüchen oder Maßnahmen von Aufsichtsbehörden entstehen, die gegen das
        Unternehmen geltend gemacht werden und die sich unmittelbar aus oder im Zusammenhang mit
        Folgendem ergeben:
        <br />
        (a) der Befolgung der Anweisungen des Kunden bezüglich der Verarbeitung personenbezogener Daten
        durch das Unternehmen; oder
        <br />
        (b) der Verletzung der Verpflichtungen des Kunden als Verantwortlicher gemäß den
        Datenschutzgesetzen.
        <br />
        10.6 Die in diesem Artikel 10 festgelegten Haftungsbeschränkungen und -ausschlüsse gelten für alle
        Ansprüche, einschließlich Schadensersatzansprüche, es sei denn, eine solche Beschränkung ist
        durch zwingende gesetzliche Bestimmungen ausdrücklich untersagt.
      </p>

      <h3>11. RECHTSWIRKUNG</h3>

      <p>
        11.1 Diese DPA wird mit dem Datum des Vertragsabschlusses für den Kunden und das Unternehmen
        rechtsverbindlich.
        <br />
        11.2 Die Bestimmungen dieser DPA bleiben über die Laufzeit des Vertrags hinaus bestehen, bis das
        Unternehmen alle personenbezogenen Daten gemäß Ziffer 7 zurückgegeben oder gelöscht hat.
      </p>

      <h3>12. ALLGEMEINES</h3>

      <p>
        12.1 Diese DPA bildet zusammen mit dem Vertrag, in den sie aufgenommen wurde, die gesamte
        Vereinbarung zwischen den Parteien in Bezug auf ihren Gegenstand.
        <br />
        12.2 Diese DPA sowie alle Streitigkeiten oder Ansprüche, die sich aus oder im Zusammenhang mit
        ihr ergeben, unterliegen dem in der Vereinbarung festgelegten Recht (griechisches Recht) und sind
        entsprechend auszulegen.
        <br />
        12.3 Jede Partei erklärt sich unwiderruflich damit einverstanden, dass die in der Vereinbarung
        genannten Gerichte (Gerichte von Athen) für die Beilegung aller Streitigkeiten oder Ansprüche
        zuständig sind, die sich aus oder im Zusammenhang mit dieser DPA ergeben.
      </p>

      <h3>ANHANG 1 – Beschreibung der Verarbeitung personenbezogener Daten</h3>

      <p>
        <strong>Gegenstand:</strong> Die Erbringung von Vermittlungsdienstleistungen durch das
        Unternehmen für den Kunden (Anbieter) gemäß der Vereinbarung, wodurch der Kunde Termine und
        Beratungen mit seinen eigenen Nutzern über die VivianLab-Plattform verwalten kann.
      </p>

      <p>
        <strong>Art:</strong> Erhebung, Speicherung, Abruf und Verwaltung von Nutzerdaten im Auftrag des
        Kunden (Anbieters), um die Terminplanung für Dienstleistungen (einschließlich der Integration von
        Google Kalender) und die Zahlungsabwicklung zu erleichtern sowie die technischen Mittel für die
        Kommunikation und Beratung zwischen dem Nutzer und dem Kunden (Anbieter) bereitzustellen.
      </p>

      <p>
        <strong>Zweck:</strong> Erfüllung des Vertrags, wodurch der Kunde (Anbieter) in die Lage
        versetzt wird, professionelle Dienstleistungen für betroffene Personen (Nutzer) zu finden, zu
        planen, zu verwalten und zu erbringen.
      </p>

      <p>
        <strong>Kategorien personenbezogener Daten (betreffend betroffene Personen):</strong>
        <br />
        Identitäts- und Kontaktdaten des Nutzers: Vorname, Nachname, E-Mail-Adresse, Telefonnummer.
        <br />
        Termin- und Leistungsdaten: Termindetails (Datum, Uhrzeit, Status), Daten aus
        Google-Kalender-Terminen (sofern der Nutzer die Integration nutzt), Details zu den vom Nutzer
        ausgewählten Leistungen, Kommunikationsinhalte, Notizen des Nutzers, Beschwerden oder Feedback zu
        den Leistungen des Auftraggebers.
      </p>

      <p>
        <strong>Sensible personenbezogene Daten (besondere Kategorien):</strong>
        <br />
        Gesundheitsdaten: Informationen über die Gesundheit, Symptome oder den Gesundheitszustand eines
        Nutzers, die der Nutzer dem Kunden (Anbieter) über die Plattform zur Verfügung stellt (z. B. in
        Terminnotizen, Mitteilungen oder während einer Beratung). Der Kunde (Anbieter) ist allein
        dafür verantwortlich, eine gültige Rechtsgrundlage (z. B. eine ausdrückliche Einwilligung) gemäß
        Artikel 9 der DSGVO für die Verarbeitung dieser Daten sicherzustellen.
      </p>

      <p>
        <strong>Kategorien von betroffenen Personen:</strong>
        <br />
        Nutzer (d. h. die eigenen Kunden/Patienten des Kunden), die über die Plattform mit dem Kunden
        (Anbieter) interagieren oder Dienstleistungen bei ihm buchen.
      </p>

      <p>
        <strong>Empfänger personenbezogener Daten (Unterauftragsverarbeiter):</strong>
        <br />
        Hosting- und Cloud-Infrastrukturanbieter (z. B. AWS, Render).
        <br />
        Zahlungsdienstleister (PSPs).
        <br />
        Analysedienstleister (z. B. Google Analytics).
        <br />
        Marketing- und Kommunikationsdienstleister (zur Erleichterung der Kommunikation).
      </p>

      <p>
        <strong>Datenübermittlungen:</strong>
        <br />
        Personenbezogene Daten werden in erster Linie innerhalb des EWR (z. B. in Deutschland)
        gespeichert.
        <br />
        Personenbezogene Daten dürfen nur dann an Unterauftragsverarbeiter außerhalb des EWR (z. B. in
        den USA) übermittelt werden, wenn ein gültiger Übermittlungsmechanismus vorhanden ist, wie
        beispielsweise die Standardvertragsklauseln der Europäischen Kommission, gemäß Ziffer 9 dieser
        DPA.
      </p>

      <p>
        <strong>Speicherung / Löschung:</strong>
        <br />
        Bei Beendigung des Vertrags oder auf schriftliche Aufforderung des Kunden (Anbieters) werden
        personenbezogene Daten gemäß Ziffer 7 dieser DPA gelöscht oder zurückgegeben. Das Unternehmen
        löscht personenbezogene Daten innerhalb von 3 Jahren nach Beendigung, sofern gesetzlich nichts
        anderes vorgeschrieben ist.
      </p>
    </div>
  );
}

export default DataPrivacyGerman;
